import React from "react";
import PropTypes from "prop-types";
import SortableHeader from "../../../../components/atoms/SortableHeader";

const labels = {
  cell_type: "Cell Type",
  tissue_type: "Tissue Type ",
  level: "Level",
  reliability: "Reliability",
};

const sortByCell = (a, b) => {
  const x = a.cell_type;
  const y = b.cell_type;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const sortByTissue = (a, b) => {
  const x = a.tissue_type;
  const y = b.tissue_type;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const sortByLevel = (a, b) => {
  const x = a.level;
  const y = b.level;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const sortByReliability = (a, b) => {
  const x = a.reliability;
  const y = b.reliability;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

function ProteinAtlasTissueInfoTable({
  items,
  sortedField,
  isAsc,
  toggleField,
}) {
  return (
    <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
      <h5>Tissue Information</h5>
      <table className="varsome-table varsome-table-sorted">
        <thead>
          <tr>
            <SortableHeader
              sort={(key) => toggleField(sortByCell, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="cell_type"
              width="40%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByTissue, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="tissue_type"
              width="25%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByLevel, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="level"
              width="20%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByReliability, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="reliability"
              width="15%"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((x) => {
            return (
              <tr key={x.id}>
                <td>{x.cell_type}</td>
                <td>{x.tissue_type}</td>
                <td style={{ color: x.levelColor }}>{x.level}</td>
                <td>{x.reliability}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

ProteinAtlasTissueInfoTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      cell_type: PropTypes.string,
      tissue_type: PropTypes.string,
      level: PropTypes.string,
      reliability: PropTypes.string,
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
};

ProteinAtlasTissueInfoTable.defaultProps = {
  items: null,
  sortedField: null,
  isAsc: true,
};
export default ProteinAtlasTissueInfoTable;
